import { restrictedRoute } from "@/routing/routes";
import { createRoute } from "@tanstack/react-router";
import { OrderDetailsPanel } from "./Details";
import { OrderPage } from ".";
import { OrderShippingDetailsPanel } from "./Shipping";
import { OrderConfirmationPage } from "./Confirm";
import { OrderPaymentPanel } from "./Payment";
import { OrderRequestPage } from "./Request";
import { OrderSummaryPanel } from "./Summary";

const index = createRoute({
  path: "order",
  getParentRoute: () => restrictedRoute,
  component: OrderPage,
});

const details = createRoute({
  path: "details",
  getParentRoute: () => index,
  component: OrderDetailsPanel,
});

const shipping = createRoute({
  path: "shipping",
  getParentRoute: () => index,
  component: OrderShippingDetailsPanel,
});

const summary = createRoute({
  path: "summary",
  getParentRoute: () => index,
  component: OrderSummaryPanel,
});

const payment = createRoute({
  path: "payment",
  getParentRoute: () => index,
  component: OrderPaymentPanel,
});

const request = createRoute({
  path: "order-request",
  getParentRoute: () => restrictedRoute,
  component: OrderRequestPage,
});

const confirm = createRoute({
  path: "order-confirm",
  getParentRoute: () => restrictedRoute,
  component: OrderConfirmationPage,
});

export const orderRoutes = index.addChildren([
  details,
  shipping,
  summary,
  payment,
]);

export const orderRequestRoute = request;
export const orderConfirmRoute = confirm;
